import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { ToastrService } from 'ngx-toastr'
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import beautify from 'xml-beautifier';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { interval } from 'rxjs';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
export class idsProductList {
  id: number;
  status: String;
  hotelName: String;
  accountingDate: any;
  pusheddate: any;
  type:any
}
@Component({
  selector: 'app-fxcrsinventory',
  templateUrl: './fxcrsinventory.component.html',
  styleUrls: ['./fxcrsinventory.component.css'],
  providers: [LoginService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class FxcrsinventoryComponent implements OnInit {
  hotellistproperty: any;
  apiresult: any;
  errorMsgSubscription: boolean;
  displayContent: boolean;
  XMLName: any;
  lstgetcmlist: any;
  selectedChannel: any;
  hotellistChannel: any;
  hotelSearchDataStatus: any;
  heartBeatData: any;
  errorMessage: string;
  dropdownDeptData: any;
  productType: any;
  today = new Date();
  constructor(private apiCallIdsService: DashboarduiService, private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) { }
  dropdownSettings = {};
  status: any = [] = [];
  hotellistCopy: any = [] = [];
  defaultData: any = [] = [];
  lstRoomlist: any = [] = [];
  count: Number = 50;
  public User: string;
  public header: string;
  display: Boolean = false;
  rateCode: string;
  selectedDate: any = new Date();
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  public SourceBy: any;
  PGF: any
  PGT: any
  public idsProductList: idsProductList[] = [];
  dataSource: MatTableDataSource<idsProductList>
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  displayedColumns: string[] = ['Status', 'Room type', 'Run date', 'Inventory', 'Received date', 'Sent date', 'Request'];

  selectedRoom: any;
  totalcount: any = 0;
  pageSize = 50;
  hotellist: any = [] = [];
  Val: string;
  selectedItems: string;
  Userid: any = [];
    /* Search Field */
    dropdownSettingsDept: IDropdownSettings = {};
    selectedDeptItems: any;

    currentDateStore: any;
    storeHeartBeatValue: any;
    blinkOfflineHotel: boolean;
    todayFuture:any = new Date();
  todayFutureOneDay: any = new Date(this.todayFuture.setDate(this.todayFuture.getDate() + 1));
  futureOneYear:any = new Date();
  futureOneYearDate: any = new Date(this.futureOneYear.setDate(this.futureOneYear.getDate() + 365));
  ngOnInit() {
    this.isProgressing = true;
    this.FOOTFALL();
    this.Pmscodevalue = localStorage.getItem("Select");
    this.SourceBy = "PushDate";
    this.callIDSUsersProperties();
    this.errorMsgSubscription = true
    this.errorMessage = "Please select property and load"
    this.displayContent = false
    this.dropdownSettingsDept = {
      idField: 'pmscustcode',
      textField: 'hotelname',
      allowSearchFilter: true,
      singleSelection: true,
      enableCheckAll: false,
      closeDropDownOnSelection:true,
      itemsShowLimit: 7,
      noDataAvailablePlaceholderText: 'No Data Found',
      searchPlaceholderText:"Search Hotel Code / Name",
    };
  }
  callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getFXCRSProperty()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          console.log("callIDSUsersProperties data? = " + JSON.stringify(data));
          
          this.apiresult = data
          this.dropdownDeptData = this.apiresult
          // this.Pmscodevalue = this.selectedItems
          this.hotellistproperty = this.apiresult;
          console.log(this.Pmscodevalue)
          this.lstgetcmlist = this.apiresult.filter((obj, pos, arr) => {
            return arr
              .map(mapObj => (mapObj.cmname))
              .indexOf(obj.cmname) == pos;
          });
          // this.selectedItems = this.hotellist[0].pmscode;
          // this.selectedChannel = this.lstgetcmlist[0].cmcode;
          this.lstgetcmlist.unshift({
            "pmscode": "0",
            "cmcode": "All",
            "pmsname": "Select Channel",
            "cmname": "Select Channel",
            "onlinestatus": " "
          });
          
          this.selectedChannel = this.lstgetcmlist[0].cmcode;
          
          this.hotellistChannel = this.lstgetcmlist;
          this.apiCallIdsService.getRoom(this.Pmscodevalue)
          .subscribe(
            data => {
              this.lstRoomlist = data;
              this.selectedRoom = data[0].name;
            } 
    
          );
          this.isProgressing = false;
        });

  }

  changePropertySearch() {
    //console.log('selectedDeptItems = ',this.selectedDeptItems.length)
    if(this.selectedDeptItems){
    if(this.selectedDeptItems.length > 0){
      // this.totalcount = 0
      console.log('if condition')
      this.totalcount = 0
      this.Pmscodevalue = this.selectedDeptItems[0].pmscustcode
      console.log('pms code value = ',this.Pmscodevalue)
      this.getroomlist(this.Pmscodevalue);
    // this.GetInventory();
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false

      var result=this.apiresult.filter((obj: { pmscustcode: MatSelectChange; })=> obj.pmscustcode == this.Pmscodevalue);
      console.log('filter record = ',result);
      this.lstgetcmlist = result;
      this.selectedChannel = this.lstgetcmlist[0].cmcode;
      // For Online Status
    this.apiCallIdsService
    .readHotelSearch(this.Pmscodevalue)
    .subscribe((data) => {
      console.log('readHotelSearch =',data)
      this.hotelSearchDataStatus = data[0].recordstatus
      this.productType = data[0].producttype
    });
      this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =',data[0])
        this.heartBeatData = data[0].heartBeat

        
// For blinking the record
const today = new Date()
console.log('Today Date = ',today);
this.currentDateStore = today.toLocaleTimeString('it-IT')
console.log('Today Date = ',this.currentDateStore);
this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
var start = this.storeHeartBeatValue.split(":");
var end = this.currentDateStore.split(":");
var startDate = new Date(0, 0, 0, start[0], start[1], 0);
var endDate = new Date(0, 0, 0, end[0], end[1], 0);
var diff = endDate.getTime() - startDate.getTime();
var hours = Math.floor(diff / 1000 / 60 / 60);
diff -= hours * 1000 * 60 * 60;
var minutes = Math.floor(diff / 1000 / 60);
// console.log('minutes difference',minutes)
console.log('minutes difference', hours + ":"  + minutes)
if((hours + ":"  + minutes) > "0:30"){
  console.log('blinkOfflineHotel true')
  this.blinkOfflineHotel = true
}else{
  console.log('blinkOfflineHotel false')
  this.blinkOfflineHotel = false
}

      });
      interval(2000 * 60).subscribe(() => {
        this.heartbeatFunction();
      });
    }
    else{
      console.log('Else condition zero')
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false
    }
  }else{
    console.log('Property Not Selected')
  }
  }

  
  GetParseonlyDateTime(d:any) {
    console.log('GetParseonlyDateTime call',d.substring(12))
    return (d.substring(12));
  }

  heartbeatFunction(){
    this.apiCallIdsService
    .readHeartbeat(this.Pmscodevalue)
    .subscribe((data) => {
      console.log('readHeartbeat =',data[0])
      this.heartBeatData = data[0].heartBeat
    });
  }

  changeDateOption(data: MatSelectChange) {
    console.log("selected --->" + data);
    this.selectedDate = new Date();
  }
  Search(event:any) {
    console.log('event= ', event)
    this.apiresult = this.hotellistproperty.filter((res: { pmscustcode: { toString: () => string; }; hotelname: { toString: () => string; }}) => {
      return res.pmscustcode.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase()) || res.hotelname.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase());
    });
      if(event == ''){
        this.Val = '';
        this.callIDSUsersProperties();
      }
  }
  closeModalDialog() {
    this.display = false; //set none css after close dialog
  }
  showXml(condition:any,xmltype: any, token: any) {
    
    if(condition == ''){
      this.status = this.LoadXML(xmltype, token);
    }else{
      this.isProgressing = true;
      this.apiCallIdsService.loadXMLData(token)
      .subscribe((res) => {
        console.log('Response =',res.content)
        this.XMLName = xmltype
        const xml = beautify(res.content);
       console.log('Beautifier',xml);
       this.defaultData = xml;
       this.display=true;
       this.isProgressing = false;
        
      })
    }
  }
  LoadXML(xmltype, token) {
    this.isProgressing = true;
    this.apiCallIdsService.getAriXML(this.Pmscodevalue, token, xmltype)
      .subscribe(data => {
        if (data.length < 1) {
          this.toastr.error('No data to load');
        }
        const xml = beautify(data[0].xmlData);
        console.log(xml);
        this.XMLName = xmltype
        this.defaultData = xml;
        this.display = true;
        this.isProgressing = false;
      },
        error => {
          this.toastr.error("Falied to load requests !");
          this.isProgressing = false;
        },

      );
  }

  getroomlist(Pmscodevalue: any) {
    this.apiCallIdsService.getRoom(this.Pmscodevalue)
      .subscribe(
        data => {
          this.lstRoomlist = data;
          for(let roomID of this.lstRoomlist){
            console.log('roomID.id',roomID.id)
            if(roomID.id == 'ALL' || roomID.id == 'all' || roomID.id == 'All'){
              console.log('roomID.name',roomID.name)
              this.selectedRoom = roomID.name;
            }
          }
          // this.selectedRoom = data[0].name;
          // this.GetInventory();
        }
      );
  }

  GetCommonMethodForLog(PMS_NUB: any) {
    this.PGF = "0";
    this.PGT = "50";
    this.GetInventory();
    //    const event: PageEvent = {
    //    length: this.paginator.length,
    //    pageIndex: 0,
    //    pageSize: this.paginator.pageSize
    // };
    // this.paginator.page.next(event); 
  }

  GetInventory() {
    this.isProgressing = true;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.apiCallIdsService.getinventory(this.Pmscodevalue, this.selectedDate, this.selectedRoom, this.SourceBy, this.PGF, this.PGT)
      .subscribe(
        data => {
          console.log('260 = ',data)
          if(data.length >0){
          this.errorMsgSubscription = false
          this.displayContent = true
          this.idsProductList=data;
          this.totalcount = data[0].totalCount;
          this.dataSource = new MatTableDataSource(this.idsProductList);
          console.log('dataSource Check= ', this.dataSource)
          console.log('pageIndex Check= ', this.paginator)
          this.dataSource.paginator = this.paginator;
          console.log('this.dataSource.paginator= ', this.dataSource.paginator)
          this.toastr.success('Data Loaded Successfully');
          this.isProgressing = false;
          }else{
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
        });
  }
  pageEvent(e:any) {
    console.log('pageEvent = ', e)
    // console.log('pageIndex = ', e.pageIndex)
    var pageIndex = e.pageIndex;
    pageIndex = pageIndex;
    console.log('pageIndex = ', pageIndex)
    this.pageSize = e.pageSize
    console.log('pageSize = ', this.pageSize)
    this.PGF = this.pageSize * pageIndex + 1;
    this.PGT = this.PGF + e.pageSize - 1;
    console.log("this.PGF", this.PGF)
    console.log("this.PGT", this.PGT)
    this.GetInventory();
  }

  FOOTFALL() {
    this.User = localStorage.getItem("Username");
    this.apiCallIdsService.getfootfall(this.User, 'FXCRS/SKYRES', 'Inventory')
      .subscribe(
        data => {
        });
  }
}
